import {useDroppable} from '@dnd-kit/core';

export default function DroppableModuleContainer({id, contents})
{
    const {setNodeRef} = useDroppable({ id: id });

    return (
        <div ref={setNodeRef} id={id} className="module-container">
            {contents}
        </div>
    );
}